import {createSelector} from 'reselect';

import {getAccountId} from '../../../../services/selectors';
import {getContractData} from '../../contracts/services/selectors';
import {parsePackages} from '../views/utils';

import type {InputSelector} from '../../../../services/typedef';
import type {ContractsListDto} from '../../contracts/typedef';
import type {State as PackagesDataState} from '../services/reducers/packagesData';
import type {ParsePackages} from '../views/utils/parsePackages';
import type {Error} from 'src/openapi/admin/models/Error';
import type {AppState} from 'src/store/typedef';

export {contractsDataSelector, getContractData, requiredContractsRefreshSelector} from '../../contracts/services/selectors';

export const getPackagesData: InputSelector<void, PackagesDataState> = state => state.apiv2.packagesData;

export const getPricingError: InputSelector<void, Error | null> = state => state.apiv2.contractsData.error;
export const getPricingBusy: InputSelector<void, boolean> = state => state.apiv2.contractsData.pricingBusy;

export const packagesDataSelector = createSelector<AppState, PackagesDataState, ParsePackages>(
    getPackagesData,
    data => parsePackages(data),
);

export const allContractNumbersSelector = createSelector<
    AppState,
    number,
    Record<number, ContractsListDto | null>,
    Array<string>
>(
    getAccountId,
    getContractData,
    (accountId, data) => {
        const dataById = data[accountId];

        return dataById ? dataById.map(contract => contract.contractInfo.contractNumber) : [];
    },
);
